import React from 'react';
import { TaskModalProvider } from 'contexts/TaskModalContext';

export default function TaskModalWrapper(props) {
  return (
    <TaskModalProvider>
      {props.children}
    </TaskModalProvider>
  )
}